// extracted by mini-css-extract-plugin
export var primitiveLabel = "_ua-0";